// extracted by mini-css-extract-plugin
export default {"title":"WgggWk","list":"y_ghYJ","item":"V4_uRs"};